import fontFamilyUI from './fontFamilyUI'
import fontSizeUI from './fontSizeUI'
import fontColorUI from './fontColorUI'
import fontStyleUI from './fontStyleUI'
import opacityUI from './opacityUI'
import editableUI from './editableUI'
import lineTypeUI from './lineTypeUI'

export default {
  fontFamilyUI,
  fontSizeUI,
  fontColorUI,
  fontStyleUI,
  opacityUI,
  editableUI,
  lineTypeUI
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/ui/index.js